import { render, staticRenderFns } from "./AllNameSpacesTable.vue?vue&type=template&id=4bffea4a&scoped=true&"
import script from "./AllNameSpacesTable.vue?vue&type=script&lang=js&"
export * from "./AllNameSpacesTable.vue?vue&type=script&lang=js&"
import style0 from "./AllNameSpacesTable.vue?vue&type=style&index=0&id=4bffea4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bffea4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VDataTable,VIcon,VTextField})
